import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AiFillSchedule } from "react-icons/ai";
import { LuUserCog } from "react-icons/lu";
import { FaUserPlus, FaPencilAlt } from "react-icons/fa";
import { IoMdArrowRoundBack } from "react-icons/io";
import { SlNote } from "react-icons/sl";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "./Menu.css";

function Menu({ users }) {
  const menuRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [popupnewuser, setpopupnewuser] = useState("");
  const [userDetail, setuserDetail] = useState({});
  const [isuseredit, setisueredit] = useState(false);
  const [isEditing, setIsEditing] = useState({
    name: false,
    email: false,
    contact: false,
    password: false,
  });

  const [error, seterror] = useState({
    confirmpassword: "",
  });

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const [createuser, setcreateuser] = useState({
    role: "",
    dept: "",
    empid: "",
    name: "",
    email: "",
    contact: "",
    shifttype: "",
    password: "",
    confirmpassword: "",
  });

  const [modifyuser, setmodifyuser] = useState({
    empid: "",
  });

  const handleCreateUser = async (e) => {
    e.preventDefault();

    const requiredFieldsFilled =
      createuser?.role &&
      createuser?.dept &&
      createuser?.empid &&
      createuser?.name &&
      createuser?.email &&
      createuser?.contact &&
      createuser?.shifttype &&
      createuser?.password &&
      createuser?.confirmpassword;

    if (!requiredFieldsFilled) {
      alert("Please enter all the required fields");
      return;
    }

    if (createuser.password !== createuser.confirmpassword) {
      seterror((prev) => ({
        ...prev,
        confirmpassword: "Please ensure both passwords match!",
      }));
      setcreateuser((prev) => ({
        ...prev,
        password: "",
        confirmpassword: "",
      }));
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/createuser.php`;
    const formData = new FormData();

    formData.append("role", createuser.role);
    formData.append("dept", createuser.dept);
    formData.append("emp_id", createuser.empid);
    formData.append("emp_name", createuser.name);
    formData.append("email", createuser.email);
    formData.append("phone_no", createuser.contact);
    formData.append("current_shift", createuser.shifttype);
    formData.append("password", createuser.password);
    formData.append("assignedby_id", userDetails?.id);

    // Since "user" and "cmanager" are not used, always send empty client_id
    // formData.append("client_id", "");

    // if (["imanager", "icoordinator", "support"].includes(createuser.role)) {
    //   formData.append("current_shift", createuser.shifttype);
    // }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      if (data.message === "User created successfully") {
        toast.success("User created successfully!");
        setcreateuser({
          role: "",
          dept: "",
          empid: "",
          name: "",
          email: "",
          contact: "",
          shifttype: "",
          password: "",
          confirmpassword: "",
        });
        setpopupnewuser("");
      } else if (data.message === "Employee is already exists") {
        // alert("User already exists!");
        // getuserdetails();
        toast.error(data.message);
        setcreateuser({
          empid: "",
        });
      }
    } catch (error) {
      console.log("Error with POST request:", error);
    }
  };

  const [modify, setmodify] = useState({
    newname: "",
    newcontact: "",
    newemail: "",
    newpassword: "",
  });

  const getmodifyuser = async (e) => {
    if (e) e.preventDefault(); // only call preventDefault if e exists

    if (!modifyuser?.empid) {
      return toast.error("Please Enter The Employee ID.");
    }
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getmodifyuser.php`;
    const formData = new FormData();
    formData.append("emp_id", modifyuser.empid);
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.message === "Records fetched successfully") {
        setuserDetail(data.data[0]);
        setisueredit(true);

        setIsEditing({
          name: false,
          email: false,
          contact: false,
          password: false,
        });
        setmodify({
          newname: "",
          newemail: "",
          newcontact: "",
          newpassword: "",
        });
      } else {
        toast.error(data.message);
        // setmodifyuser({
        //   empid: "",
        // });
      }
    } catch (error) {
      console.log("Error fetching tickets:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handlemodify = async () => {
    if (
      modify.newname &&
      modify.newcontact &&
      modify.newemail &&
      modify.newpassword
    ) {
      alert("Please fill anyone of the fields");
      return;
    }
    {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/modifyuser.php`;
      const formData = new FormData();

      formData.append("id", userDetail.id);
      formData.append("emp_name", modify?.newname || userDetail.emp_name);
      formData.append("email", modify?.newemail || userDetail.email);
      formData.append("phone_no", modify?.newcontact || userDetail.phone_no);
      formData.append("password", modify?.newpassword || userDetail.password);

      const response = fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setmodify({
            newname: "",
            newemail: "",
            newcontact: "",
            newpassword: "",
          });
          setIsEditing({
            name: false,
            email: false,
            contact: false,
            password: false,
          });
          alert(data.message);
          getmodifyuser();
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="menu-container">
      <div className="menubn">
        <button className="btn" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span className="icon">
            <svg viewBox="0 0 175 80" width={40} height={40}>
              <rect width={80} height={15} fill="#f0f0f0" rx={10} />
              <rect y={30} width={80} height={15} fill="#f0f0f0" rx={10} />
              <rect y={60} width={80} height={15} fill="#f0f0f0" rx={10} />
            </svg>
          </span>
          <span className="text">MENU</span>
        </button>
      </div>

      {isMenuOpen && (
        <div className="admin-portal-menu-box" ref={menuRef}>
          <button
            className="admin-portal-menu-item"
            onClick={() => setpopupnewuser("createuser")}
          >
            <FaUserPlus /> CREATE NEW USERS
          </button>

          {userDetails?.role === "admin" && (
            <>
              <button
                className="admin-portal-menu-item"
                onClick={() => setpopupnewuser("modifyuser")}
              >
                <LuUserCog /> MODIFY & UPDATE
              </button>

              <Link to="/shift" state={{}} style={{ textDecoration: "none" }}>
                <button className="admin-portal-menu-item">
                  <AiFillSchedule /> SHIFT SCHEDULE
                </button>
              </Link>
            </>
          )}

          <Link
            to="/reports"
            state={{ users }}
            style={{ textDecoration: "none" }}
          >
            <button className="admin-portal-menu-item">
              <SlNote /> REPORTS
            </button>
          </Link>
        </div>
      )}

      {popupnewuser === "createuser" && (
        <div className="admin-portal-popup-overlay">
          <div
            className="admin-portal-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="admin-portal-header">
              <button
                className="admin-portal-back-btn"
                onClick={() => setpopupnewuser("")}
              >
                <IoMdArrowRoundBack className="admin-portal-svg-icon" />
              </button>
              <h2 className="admin-portal-form-title">Create New User</h2>
            </div>

            <div className="admin-portal-form-section">
              <form onSubmit={handleCreateUser} className="admin-portal-form">
                <div>
                  <span className="admin-portal-label">Role: </span>
                  <select
                    required
                    className="admin-portal-select"
                    value={createuser?.role}
                    onChange={(e) =>
                      setcreateuser((pv) => ({
                        ...pv,
                        role: e.target.value,
                      }))
                    }
                  >
                    <option value="" disabled selected>
                      Select Role
                    </option>

                    <>
                      <option value="executive">Executive Assistance</option>
                      <option value="manager">Manager</option>
                      <option value="employee">Employee</option>
                    </>

                    {/* <option value="cmanager">Client Manager</option> */}
                    {/* <option value="user">User</option> */}
                  </select>

                  <span className="admin-portal-label">Department: </span>
                  <select
                    required
                    className="admin-portal-select"
                    value={createuser?.dept}
                    onChange={(e) =>
                      setcreateuser((pv) => ({
                        ...pv,
                        dept: e.target.value,
                      }))
                    }
                  >
                    <option value="" disabled selected>
                      Select Department
                    </option>

                    <option value="admin">Admin</option>
                    <option value="hr">Human Recourses</option>
                    <option value="recuitement">Recuitement</option>
                    <option value="development">Development</option>
                    <option value="accounts">Accounts</option>
                    <option value="sales">Sales</option>
                    <option value="support">Support</option>
                    <option value="training">Training</option>

                    {/* <option value="cmanager">Client Manager</option> */}
                    {/* <option value="user">User</option> */}
                  </select>

                  <span className="admin-portal-label">Employee ID: </span>
                  <input
                    type="text"
                    placeholder="Enter a Employee ID"
                    required
                    value={createuser?.empid}
                    onChange={(e) =>
                      setcreateuser((pv) => ({
                        ...pv,
                        empid: e.target.value,
                      }))
                    }
                    className="admin-portal-input"
                  />

                  <span className="admin-portal-label">Employee Name: </span>
                  <input
                    type="text"
                    placeholder="Enter a Employee Name"
                    required
                    value={createuser?.name}
                    onChange={(e) =>
                      setcreateuser((pv) => ({
                        ...pv,
                        name: e.target.value,
                      }))
                    }
                    className="admin-portal-input"
                  />

                  <span className="admin-portal-label">Contact No: </span>
                  <input
                    type="tel"
                    pattern="[0-9]{10}"
                    title="Please enter exactly 10 digits"
                    placeholder="Enter Contact"
                    required
                    value={createuser?.contact}
                    onChange={(e) =>
                      setcreateuser((pv) => ({
                        ...pv,
                        contact: e.target.value,
                      }))
                    }
                    className="admin-portal-input"
                  />
                </div>
                <div>
                  <span className="admin-portal-label">Email: </span>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    required
                    value={createuser?.email}
                    onChange={(e) =>
                      setcreateuser((pv) => ({
                        ...pv,
                        email: e.target.value,
                      }))
                    }
                    className="admin-portal-input"
                  />

                  <span className="admin-portal-label">Shift type: </span>
                  <select
                    required
                    className="admin-portal-select"
                    value={createuser?.shifttype}
                    onChange={(e) =>
                      setcreateuser((pv) => ({
                        ...pv,
                        shifttype: e.target.value,
                      }))
                    }
                  >
                    <option value="" disabled defaultChecked>
                      Select Shift
                    </option>

                    <option value={"General Shift - GS"}>
                      General Shift - GS
                    </option>
                    <option value={"First Shift - S1"}>First Shift - S1</option>
                    <option value={"Second Shift - S2"}>
                      Second Shift - S2
                    </option>
                    <option value={"Third Shift - S3"}>Third Shift - S3</option>
                  </select>

                  <span className="admin-portal-label">Password: </span>
                  <input
                    type="password"
                    placeholder="Enter Password"
                    required
                    className="admin-portal-input"
                    value={createuser?.password}
                    onChange={(e) =>
                      setcreateuser((pv) => ({
                        ...pv,
                        password: e.target.value,
                      }))
                    }
                  />

                  <span className="admin-portal-label">Confirm Password: </span>
                  <input
                    type="password"
                    placeholder="Confirm Password"
                    required
                    className="admin-portal-input"
                    value={createuser?.confirmpassword}
                    onChange={(e) => {
                      setcreateuser((pv) => ({
                        ...pv,
                        confirmpassword: e.target.value,
                      }));

                      if (createuser?.password === e.target.value) {
                        seterror((prev) => ({
                          ...prev,
                          confirmpassword: "",
                        }));
                      }
                    }}
                  />
                  {error.confirmpassword && (
                    <p className="error-msg">{error.confirmpassword}</p>
                  )}

                  <button type="submit" className="admin-portal-btn-create">
                    Create
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* create user  */}
      {popupnewuser === "modifyuser" && (
        <div className="admin-portal-popup-overlay">
          <div
            className="admin-portal-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="admin-portal-header">
              <button
                className="admin-portal-back-btn"
                onClick={() => (
                  setpopupnewuser(""),
                  setisueredit(false),
                  setmodifyuser({
                    empid: "",
                  })
                )}
              >
                <IoMdArrowRoundBack className="admin-portal-svg-icon" />
              </button>
              <h2 className="admin-portal-form-title">Modify & Update</h2>
            </div>

            <div className="admin-portal-form-section">
              <form
                // onSubmit={getmodifyuser}
                className="admin-modifyportal-form"
              >
                <div>
                  <span className="admin-portal-label">Employee ID: </span>
                  <input
                    type="text"
                    placeholder="Enter a Employee ID"
                    required
                    value={modifyuser?.empid}
                    onChange={(e) =>
                      setmodifyuser((pv) => ({
                        ...pv,
                        empid: e.target.value,
                      }))
                    }
                    className="admin-portal-input"
                  />

                  <button
                    type="submit"
                    onClick={getmodifyuser}
                    className="admin-portal-btn-create"
                  >
                    Search
                  </button>
                </div>
              </form>

              <AnimatePresence>
                {isuseredit && (
                  <motion.div
                    initial={{ x: "-100%" }} // Starts off-screen to the left
                    animate={{ x: 0 }} // Slides into view
                    exit={{ x: "-350%" }} // Slides out to the left on unmount
                    transition={{ type: "close", stiffness: 80 }}
                    className="user-detail-popup"
                  >
                    <button
                      className="close-popup"
                      onClick={() => (
                        setisueredit(false),
                        setmodifyuser({
                          empid: "",
                        }),
                        setIsEditing({
                          name: false,
                          email: false,
                          contact: false,
                          password: false,
                        }),
                        setmodify({
                          newname: "",
                          newemail: "",
                          newcontact: "",
                          newpassword: "",
                        })
                      )}
                    >
                      &times;
                    </button>
                    <h4 className="userh4">{userDetail?.emp_name}`s Info</h4>

                    <div className="user-info-section">
                      <p>
                        <strong>Role:</strong> {userDetail.role}{" "}
                        <strong>Department:</strong> {userDetail.dept}{" "}
                      </p>

                      {/* Name */}
                      {!isEditing?.name ? (
                        <p>
                          <strong>Name:</strong> {userDetail.emp_name}
                          <button
                            onClick={() =>
                              setIsEditing((prev) => ({
                                ...prev,
                                name: true,
                              }))
                            }
                          >
                            <FaPencilAlt />
                          </button>
                        </p>
                      ) : (
                        <div className="input-block">
                          <label>
                            <strong>Name:</strong>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter name"
                            value={modify?.newname}
                            onChange={(e) =>
                              setmodify((prev) => ({
                                ...prev,
                                newname: e.target.value,
                              }))
                            }
                          />
                          <button
                            onClick={() =>
                              setIsEditing((prev) => ({
                                ...prev,
                                name: false,
                              }))
                            }
                          >
                            &times;
                          </button>
                        </div>
                      )}

                      {/* Email */}
                      {!isEditing?.email ? (
                        <p>
                          <strong>Email:</strong> {userDetail.email}{" "}
                          <button
                            onClick={() =>
                              setIsEditing((prev) => ({
                                ...prev,
                                email: true,
                              }))
                            }
                          >
                            <FaPencilAlt />
                          </button>
                        </p>
                      ) : (
                        <div className="input-block">
                          <label>
                            <strong>Email:</strong>
                          </label>
                          <input
                            type="email"
                            placeholder="Enter email"
                            value={modify?.newemail}
                            onChange={(e) =>
                              setmodify((prev) => ({
                                ...prev,
                                newemail: e.target.value,
                              }))
                            }
                          />
                          <button
                            onClick={() =>
                              setIsEditing((prev) => ({
                                ...prev,
                                email: false,
                              }))
                            }
                          >
                            &times;
                          </button>
                        </div>
                      )}

                      {/* Contact */}
                      {!isEditing?.contact ? (
                        <p>
                          <strong>Contact:</strong> {userDetail.phone_no}{" "}
                          <button
                            onClick={() =>
                              setIsEditing((prev) => ({
                                ...prev,
                                contact: true,
                              }))
                            }
                          >
                            <FaPencilAlt />
                          </button>
                        </p>
                      ) : (
                        <div className="input-block">
                          <label>
                            <strong>Contact:</strong>
                          </label>
                          <input
                            type="tel"
                            pattern="[0-9]{10}"
                            placeholder="Enter contact number"
                            value={modify?.newcontact}
                            onChange={(e) =>
                              setmodify((prev) => ({
                                ...prev,
                                newcontact: e.target.value,
                              }))
                            }
                          />
                          <button
                            onClick={() =>
                              setIsEditing((prev) => ({
                                ...prev,
                                contact: false,
                              }))
                            }
                          >
                            &times;
                          </button>
                        </div>
                      )}

                      {/* Password */}
                      {!isEditing?.password ? (
                        <p>
                          <strong>Password:</strong> *********{" "}
                          <button
                            onClick={() =>
                              setIsEditing((prev) => ({
                                ...prev,
                                password: true,
                              }))
                            }
                          >
                            <FaPencilAlt />
                          </button>
                        </p>
                      ) : (
                        <div className="input-block">
                          <label>
                            <strong>Password:</strong>
                          </label>
                          <input
                            type="tel"
                            pattern="[0-9]{10}"
                            placeholder="Enter Password"
                            value={modify?.newpassword}
                            onChange={(e) =>
                              setmodify((prev) => ({
                                ...prev,
                                newpassword: e.target.value,
                              }))
                            }
                          />
                          <button
                            onClick={() =>
                              setIsEditing((prev) => ({
                                ...prev,
                                password: false,
                              }))
                            }
                          >
                            &times;
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="sbtn1">
                      <p>
                        <button className="sbtn" onClick={handlemodify}>
                          Submit
                        </button>
                      </p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Menu;
